import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Checkbox,
  ListItemText,
  Divider,
  withWidth,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MuiPhoneNumber from "material-ui-phone-number";
import React, { useEffect, useState } from "react";

const services = [
  {
    value: "Mowing",
    label: "Mowing",
  },
  {
    value: "Edging",
    label: "Edging",
  },
  {
    value: "Trimming",
    label: "Trimming",
  },
  {
    value: "Blowing",
    label: "Blowing",
  },
  {
    value: "Weed Control",
    label: "Weed Control",
  },
  {
    value: "Mulching",
    label: "Mulching",
  },
  {
    value: "Leaf Cleanup and Removal",
    label: "Leaf Cleanup and Removal",
  },
  {
    value: "Yard Cleanup",
    label: "Yard Cleanup",
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: "80.5vh",
    fontFamily: "Nunito",
    background: "#fff",
  },
  topGrid: { margin: theme.spacing(0), width: "100%" },
  bottomGrid: {
    margin: theme.spacing(0),
    marginTop: theme.spacing(4),
    width: "100%",
  },
  infoGrid: { margin: theme.spacing(0), padding: theme.spacing(2) },
  paper: {
    padding: theme.spacing(2),
    margin: "auto",
  },
  title: {
    marginTop: theme.spacing(1),
  },
  form: {
    marginTop: theme.spacing(0),
  },
  submitButton: { marginTop: theme.spacing(1), float: "right" },
  redAsterik: { color: "red" },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: "75%",
  },
}));

const ContactUs = (props) => {
  const classes = useStyles();

  const { setCurrPage, width } = props;
  console.log(width);
  const [formContent, setFormContent] = useState({
    firstName: { value: "", error: false, errorMessage: "" },
    lastName: { value: "", error: false, errorMessage: "" },
    phone: { value: "", error: false, errorMessage: "" },
    email: { value: "", error: false, errorMessage: "" },
    services: [],
    message: "",
    sent: false,
  });

  useEffect(() => {
    setCurrPage("Contact Us");
  }, [setCurrPage]);

  const handleFormContent = (event) => {
    let tmpForm = { ...formContent };
    tmpForm[event.target.id].value = event.target.value;
    setFormContent(tmpForm);
  };

  const handlePhoneChange = (value) => {
    if (value) {
      let tmpForm = { ...formContent };
      tmpForm["phone"].value = value;
      setFormContent(tmpForm);
    }
  };

  const handleServicesChange = (event) => {
    let tmpForm = { ...formContent };
    tmpForm["services"] = event.target.value;
    console.log(tmpForm);
    setFormContent(tmpForm);
  };

  const handleSubmit = () => {
    let tmpForm = { ...formContent };
    let changes = false;
    var emailRe = /\S+@\S+\.\S+/;
    var phoneRe = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im; // eslint-disable-line

    for (let key of Object.keys(tmpForm)) {
      if (key !== "message" && key !== "sent") {
        console.log(key);
        if (tmpForm[key].value === "") {
          changes = true;
          tmpForm[key].error = true;
          tmpForm[key].errorMessage = "Enter Value";
        } else if (key === "email" && !emailRe.test(tmpForm[key].value)) {
          changes = true;
          tmpForm[key].error = true;
          tmpForm[key].errorMessage = "Enter a Valid Email";
        } else if (key === "phone" && !phoneRe.test(tmpForm[key].value)) {
          changes = true;
          tmpForm[key].error = true;
          tmpForm[key].errorMessage = "Enter a Valid Phone Nunber";
        } else {
          console.log(key);
          tmpForm[key].error = false;
        }
      }
    }
    if (changes === true) {
      setFormContent(tmpForm);
    } else {
      // email
      console.log("Valid");
    }
  };

  return (
    <div className={classes.root}>
      <Grid
        className={classes.topGrid}
        container
        justify="center"
        alignItems="center"
        direction="column"
        spacing={1}
      >
        <Grid item xs={12}>
          <h3 style={{ marginTop: "10px" }}>
            Thank you for visiting the website of C&R Exterior Services, LLC. If
            you have any questions, please use the form on this page to email
            us.
          </h3>
        </Grid>
      </Grid>
      <Grid
        className={classes.bottomGrid}
        container
        spacing={3}
        direction={width === "xs" || width === "sm" ? "column" : "row"}
        justify="center"
        alignItems={width === "xs" || width === "sm" ? "center" : "flex-start"}
      >
        <Grid item xs={12} md={3}>
          <Grid item xs={12}>
            <Paper className={classes.paper} elevation={3}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Grid item xs={12} className={classes.title}>
                    <h4>C&R Exterior Services, LLC.</h4>
                    <Divider light className={classes.divider} />
                  </Grid>
                  <Grid item xs={12} className={classes.title}>
                    <h4>
                      436 Porta Rosa Cir. <br />
                      St Augustine, FL 32092
                    </h4>
                  </Grid>
                  <Grid item xs={12} className={classes.title}>
                    <h4>Call Us</h4>
                  </Grid>
                  <Grid item xs={12}>
                    <h5>Phone: (908) 544-7160</h5>
                    <Divider light className={classes.divider} />
                  </Grid>
                  <Grid item xs={12} className={classes.title}>
                    <h4>Hours</h4>
                  </Grid>
                  <Grid item xs={12}>
                    <h5>Mon: 7:30AM-5:00PM</h5>
                  </Grid>
                  <Grid item xs={12}>
                    <h5>Tues: 7:30AM-5:00PM</h5>
                  </Grid>
                  <Grid item xs={12}>
                    <h5>Wed: 7:30AM-5:00PM</h5>
                  </Grid>
                  <Grid item xs={12}>
                    <h5>Thurs: 7:30AM-5:00PM</h5>
                  </Grid>
                  <Grid item xs={12}>
                    <h5>Fri: 7:30AM-5:00PM</h5>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Grid item xs={12}>
            <Paper className={classes.paper} elevation={3}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <h1>Contact Us</h1>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "10px" }}>
                  <h2>
                    Name <span className={classes.redAsterik}>*</span>
                  </h2>
                </Grid>
                <Grid item xs={6}>
                  <FormControl
                    variant="outlined"
                    className={classes.form}
                    fullWidth
                  >
                    <TextField
                      error={formContent.firstName.error ? true : false}
                      helperText={
                        formContent.firstName.error
                          ? formContent.firstName.errorMessage
                          : ""
                      }
                      id="firstName"
                      label="First"
                      placeholder="Enter First Name"
                      variant="outlined"
                      margin="normal"
                      value={formContent.firstName.value}
                      onChange={handleFormContent}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl
                    variant="outlined"
                    className={classes.form}
                    fullWidth
                  >
                    <TextField
                      error={formContent.lastName.error ? true : false}
                      helperText={
                        formContent.lastName.error
                          ? formContent.lastName.errorMessage
                          : ""
                      }
                      id="lastName"
                      label="Last"
                      placeholder="Enter Last Name"
                      variant="outlined"
                      margin="normal"
                      value={formContent.lastName.value}
                      onChange={handleFormContent}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "10px" }}>
                  <h2>
                    Phone <span className={classes.redAsterik}>*</span>
                  </h2>
                </Grid>
                <Grid item xs={12}>
                  <FormControl
                    variant="outlined"
                    className={classes.form}
                    fullWidth
                  >
                    <MuiPhoneNumber
                      error={formContent.phone.error ? true : false}
                      helperText={
                        formContent.phone.error
                          ? formContent.phone.errorMessage
                          : ""
                      }
                      disableCountryCode
                      id="phone"
                      label="Phone Number"
                      disableDropdown
                      defaultCountry={"us"}
                      variant="outlined"
                      margin="normal"
                      value={formContent.phone.value}
                      regions={"north-america"}
                      onChange={handlePhoneChange}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "10px" }}>
                  <h2>
                    Email <span className={classes.redAsterik}>*</span>
                  </h2>
                </Grid>
                <Grid item xs={12}>
                  <FormControl
                    variant="outlined"
                    className={classes.form}
                    fullWidth
                  >
                    <TextField
                      id="email"
                      error={formContent.email.error ? true : false}
                      helperText={
                        formContent.email.error
                          ? formContent.email.errorMessage
                          : ""
                      }
                      placeholder="Enter Email Address"
                      label="Email"
                      variant="outlined"
                      margin="normal"
                      value={formContent.email.value}
                      onChange={handleFormContent}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "10px" }}>
                  <h2>Services</h2>
                </Grid>
                <Grid item xs={12}>
                  <FormControl
                    variant="outlined"
                    className={classes.form}
                    fullWidth
                    style={{ marginTop: "16px", marginBottom: "8px" }}
                  >
                    <InputLabel id="services-select-outlined-label">
                      Services
                    </InputLabel>
                    <Select
                      labelId="services-select-outlined-label"
                      id="outlined-select-services"
                      multiple
                      value={formContent.services}
                      onChange={handleServicesChange}
                      label="Services"
                      renderValue={(selected) => selected.join(", ")}
                    >
                      {services.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          <Checkbox
                            checked={
                              formContent.services.indexOf(option.value) > -1
                            }
                          />
                          <ListItemText primary={option.label} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "10px" }}>
                  <h2>Message</h2>
                </Grid>
                <Grid item xs={12}>
                  <FormControl
                    variant="outlined"
                    className={classes.form}
                    fullWidth
                  >
                    <TextField
                      id="message"
                      label="Message"
                      variant="outlined"
                      margin="normal"
                      placeholder="Enter a Message for Us!"
                      multiline
                      value={formContent.message}
                      onChange={handleFormContent}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    className={classes.submitButton}
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
export default withWidth()(ContactUs);
